import {
  Divider,
  Grid,
  Stack
} from '@mui/material';

const CardsWrapper = ({
   title,
  children
}) => {
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ px: 2, py: 1.5 }}
      >
        {title}
      </Stack>
      {/* <Divider /> */}
      <Grid container >
        {children}      
      </Grid>
      </>
  );
};

export default CardsWrapper;
